import React from 'react';
import { View, StyleSheet, Text } from 'react-native';

import { Charge, TransactionItem } from 'apollo/queries/autogenerate/schemas';
import ReceiptView from 'shared/modules/usage/components/organisms/ReceiptView';
import {
  getCurrentInstallmentIndex,
  getTotalInstallment,
} from 'shared/modules/usage/utils/charge-utils';
import PostpaidUsage from 'web/modules/common/components/organisms/AppleChargeDetailsDialog/PostpaidUsage';

type Props = {
  charge: Charge;
  transactionItem: TransactionItem;
};

export default function AppleChargeDetails(props: Props) {
  if (!props.charge.installmentPlanOptions) {
    return null;
  }

  const currentInstallmentIndex = getCurrentInstallmentIndex(props.charge);
  const totalInstallment = getTotalInstallment(props.charge);

  if (currentInstallmentIndex === -1 || !totalInstallment) {
    return null;
  }

  return (
    <View>
      <PostpaidUsage
        item={props.transactionItem}
        currentInstallment={currentInstallmentIndex}
        totalInstallment={totalInstallment}
      />
      <View style={styles.separator} />
      {props.charge.payment && (
        <ReceiptView
          payment={props.charge.payment}
          orderNumber={props.transactionItem.orderNumber}
        />
      )}
      <View style={styles.chargeMessageContainer}>
        <Text style={[styles.chargeMessageText, styles.chargeMessageTitle]}>
          ※ご注意
        </Text>
        <Text style={[styles.chargeMessageText, styles.chargeMessageAppleText]}>
          ペイディあと払いプランApple専用については、ペイディアプリからご確認ください。
        </Text>
        <Text style={styles.chargeMessageText}>
          翌月一回払いを除き、商品の種類又は品質に関して契約の内容に適合しない場合や、役務の未提供などを理由に支払いを止めることができる場合があります。その場合は、ペイディカスタマーサポートへご連絡ください。ただし、予め販売店と交渉を行なうよう努めていただくものとします｡
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  separator: {
    height: 16,
  },
  chargeMessageContainer: {
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  chargeMessageText: {
    fontSize: 13,
    lineHeight: 16,
    color: '#586065',
  },
  chargeMessageTitle: {
    fontWeight: '700',
    marginBottom: 8,
  },
  chargeMessageAppleText: {
    marginBottom: 8,
  },
});
